import React from 'react';
import './style.scss';
import { findAssetByWellName } from '../../../../features/recommendations/Table-widgets/TableData/RecommendationsTableData';

interface WellNameProps {
  value: string; // Type the info prop
}

const WellName: React.FC<WellNameProps> = ({ value }) => {
  const handleWellFieldClick = () => {
    const baseUrl = window.location.origin;
    const asset = findAssetByWellName(value);
    if (!asset?.assetId) return;

    if (!asset.groupName) return;
    const targetUrl = `${baseUrl}/asset/charts/${asset.assetId}/${encodeURIComponent(asset.groupName)}`;
    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='well-name-cell' onClick={handleWellFieldClick}>
      {value}
    </div>
  );
};
export default WellName;
